import { render, staticRenderFns } from "./examSidebar.vue?vue&type=template&id=2d58bafe&scoped=true"
import script from "./examSidebar.vue?vue&type=script&lang=js"
export * from "./examSidebar.vue?vue&type=script&lang=js"
import style0 from "./examSidebar.vue?vue&type=style&index=0&id=2d58bafe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d58bafe",
  null
  
)

export default component.exports